var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useContext, useEffect, useState } from 'react';
import { LoadingSpinner } from '../common/loading-spinner';
import { useAxiosGet } from '../hooks';
import { AnswersUploadPanel } from './answers-upload-panel';
import { formatPregradingStatus } from './format-held-exams';
import { HeldExam } from './held-exam';
import { useTranslation } from 'react-i18next';
import { PregradingExamUrlsContext } from './pregrading';
export const PregradingExams = ({ scopeId, roleType, allowedExams, examReviewRequired, examsDeletable }) => {
    const pregradingExamUrls = useContext(PregradingExamUrlsContext);
    const [heldExams, setHeldExams] = useState([]);
    const [examsWithGrader, setExamsWithGrader] = useState([]);
    const [showDeleted, setShowDeleted] = useState(false);
    const [get, loading] = useAxiosGet();
    const { t } = useTranslation();
    const loadHeldExams = (schoolId) => __awaiter(void 0, void 0, void 0, function* () {
        const data = yield get(pregradingExamUrls.heldExams(schoolId));
        if (data) {
            setHeldExams(formatPregradingStatus(data));
        }
    });
    useEffect(() => {
        void (() => __awaiter(void 0, void 0, void 0, function* () {
            if (roleType !== 'PRINCIPAL')
                return setExamsWithGrader([]);
            const data = yield get(pregradingExamUrls.examsWithGrader(scopeId));
            if (data) {
                setExamsWithGrader(data);
            }
        }))();
    }, [roleType, scopeId]);
    useEffect(() => void loadHeldExams(scopeId), [scopeId]);
    const heldExamsWithAllowedInformation = heldExams.map(exam => (Object.assign(Object.assign({}, exam), { isAllowedExam: allowedExams.includes(exam.examCode.replace(/_X|_E/, '')) || roleType === 'PRINCIPAL' })));
    const hasDeadlineDate = heldExamsWithAllowedInformation.some(exam => !!exam.pregradingDeadlines.intDeadline.date || !!exam.pregradingDeadlines.finalDeadline.date);
    return (React.createElement("div", { id: "exam-grading-tab", className: "tab" },
        React.createElement(LoadingSpinner, { loading: loading }),
        React.createElement(AnswersUploadPanel, { schoolId: scopeId, isPrincipal: roleType === 'PRINCIPAL', loadHeldExams: loadHeldExams }),
        React.createElement("h3", null, t('sa.held_exams')),
        React.createElement("p", { className: "info-text" }, t('sa.info_text')),
        examsDeletable && (React.createElement(React.Fragment, null,
            React.createElement("input", { type: "checkbox", id: "show-deleted-held-exams", className: "show-deleted-input", onClick: e => setShowDeleted(e.currentTarget.checked) }),
            ' ',
            React.createElement("label", { htmlFor: "show-deleted-held-exams", className: "show-deleted-label", "data-i18n": "sa.show_deleted" }, t('sa.show_deleted')))),
        React.createElement("table", { id: "held-exams", className: "is_pregrading held-exams-table basic-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { className: "examDate" }, t('sa.yo.exam_date')),
                    React.createElement("th", { className: "examName" }, t('sa.held_exam_name')),
                    React.createElement("th", { className: "schoolAnonCode" }, t('sa.yo.school_anon_code')),
                    React.createElement("th", { className: "students" }, t('sa.students')),
                    React.createElement("th", { className: "answers" }, t('sa.held_answers')),
                    React.createElement("th", { className: "progress" },
                        React.createElement("div", { className: "pregrading_graded" }, t('sa.pre_grading_answers_graded')),
                        React.createElement("div", { className: "pregrading_finished" }, t('sa.pre_grading_answers_finished'))),
                    React.createElement("th", { className: "work-left" }, hasDeadlineDate ? t('sa.recommended_deadline') : ''),
                    React.createElement("th", { className: "grading-links", colSpan: 1 + (examReviewRequired ? 1 : 0) + (examsDeletable ? 1 : 0) }))),
            React.createElement("tbody", null, heldExamsWithAllowedInformation.map(exam => (React.createElement(HeldExam, Object.assign({ key: exam.uuid }, exam, { schoolId: scopeId, activeRole: roleType, examHasGrader: examsWithGrader.includes(exam.examCode.replace(/_X|_E/, '')), pregradingScores: exam.pregradingScores, examReviewRequired: examReviewRequired, examsDeletable: examsDeletable, setHeldExams: setHeldExams, heldExamDeletionDate: exam.heldExamDeletionDate, showDeleted: showDeleted }))))))));
};
//# sourceMappingURL=pregrading-exams.js.map